// extracted by mini-css-extract-plugin
export default {"no-of-results":"list-renderer__no-of-results--SWwoq","noOfResults":"list-renderer__no-of-results--SWwoq"};